import { render, staticRenderFns } from "./PowerupHierarchyLink.vue?vue&type=template&id=77fa40ef"
import script from "./PowerupHierarchyLink.vue?vue&type=script&lang=js"
export * from "./PowerupHierarchyLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports